// src/utils/logging.js
import { collection, addDoc, Timestamp } from "firebase/firestore";
import { db } from "../FirebaseConfig";

export const logBoundingBoxAction = async ({
  email,
  photopath,
  cultiverName,
  boxId,
  action,      // 例: "created", "deleted", "title changed", etc
  details = {} // オプションで追加情報をオブジェクトで渡せる
}) => {
  try {
    const logRef = collection(db, "boundingBoxLogs"); // ← コレクション名は任意で変更可
    await addDoc(logRef, {
      email,
      photopath,
      cultiverName,
      boxId,
      action,
      details,
      timestamp: Timestamp.now(),
      userAgent: navigator.userAgent,
    });
    console.log("✅ Log saved:", { action, boxId });
  } catch (err) {
    console.error("⚠️ Logging failed:", err);
  }
};
